import Vue from "vue";
import Vuex from "vuex";
import router from "../router";


const Environnement = {
    namespaced: true,
    state: {
        envModer: {
            dos_cod_t: '',
            dos_lib_t: '',
            dos_log_t: '',
            dos_tit_t: '',
            env_flag_t: '',
            env_id_n: null,
            env_nom_t: ''
        },
        envAssign: {
            dos_cod_t: '',
            dos_lib_t: '',
            dos_log_t: '',
            dos_tit_t: '',
            env_flag_t: '',
            env_id_n: null,
            env_nom_t: ''
        },
        envs: []
    },
    actions: {
        getEnvironnements(context, user) {
            let data = new FormData();
            data.append("userId", user.userId);
            data.append("role", user.role);

            return new Promise((resolve, reject) => {
                Vue.axios.post(window.urlapi + "getDosList.php", data).then(
                    response => {
                        context.commit("GETENVS", response.data.data);
                        for (let i = 0; i < response.data.data.length; i++) {
                            if (window.env_assign.indexOf(response.data.data[i].env_id_n) > -1) {
                                context.commit("GETENVASSIGN", response.data.data[i]);
                                localStorage.setItem('env_assign', JSON.stringify(response.data.data[i]));
                            }

                            if (window.env_moder.indexOf(response.data.data[i].env_id_n) > -1) {
                                context.commit("GETENVMODER", response.data.data[i]);
                                localStorage.setItem('env_moder', JSON.stringify(response.data.data[i]));
                            }
                        }
                        resolve();
                    }
                );
            })
        },
        setEnvironnement(context, { env, type }) {
            // if (type === null) type = 'env_assign';
            context.commit('SETENV', env);
            localStorage.setItem(type, JSON.stringify(env));
        }
    },
    mutations: {
        GETENVS: (state, envs) => {
            state.envs = envs;
        },
        SETENV: (state, env) => {
            state.env = env;
        },
        GETENVASSIGN: (state, envAssign) => {
            state.envAssign = envAssign;
        },
        GETENVMODER: (state, envModer) => {
            state.envModer = envModer;
        }
    },
    getters: {
        envs: state => {
            return state.envs;
        },
        envAssign: state => {
            if (typeof state.envAssign === 'undefined' || state.envAssign.env_id_n == null)
                return JSON.parse(localStorage['env_assign']);

            return state.envAssign;
        },
        envModer: state => {
            if (typeof state.envModer === 'undefined' || state.envModer.env_id_n == null)
                return JSON.parse(localStorage['env_moder']);

            return state.envModer;
        }
    }
}

export default Environnement;